export default __webpack_public_path__ + "static/media/calendar.e0ecb85b.svg";